import React from "react";
import { Descriptions } from "antd";

const OrderTotlesLists = (props) => {
  return (
    <Descriptions className="listLabelBold">
      <Descriptions.Item label="Subtotal" span={3}>
        {props.orderData && props.orderData[0] && props.orderData[0].order_details.sub_total ? "Rs "+props.orderData[0].order_details.sub_total : "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Delivery Fee" span={3}>
        {props.orderData && props.orderData[0] && props.orderData[0].order_details.delivery_charges ? "Rs "+props.orderData[0].order_details.delivery_charges : "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Total" span={3}>
      {props.orderData && props.orderData[0] && props.orderData[0].order_details.total_amount ? "Rs "+props.orderData[0].order_details.total_amount : "-"}
      </Descriptions.Item>
      <Descriptions.Item label="Pay at Pickup" span={3}>
        --
      </Descriptions.Item>
      <Descriptions.Item label="Collect at Dropoff" span={3}>
        {props.orderData && props?.orderData[0] && props?.orderData[0]?.order_details?.invoice.amount ? "Rs "+props.orderData[0]?.order_details?.invoice?.amount : "--"}
      </Descriptions.Item>
    </Descriptions>
  );
};
export default OrderTotlesLists;
